import { sendActionEmail } from "../emails/send";

/**
 * ═══ SE FAIRE ENVOYER DE QUOI ENTRER ═══
 *
 * Un seul appel pour deux usages qui n'en font qu'un : « j'ai oublié mon mot de passe »
 * et la connexion SANS mot de passe, où l'adresse suffit et le lien arrive par courrier.
 * La V1 les sert déjà avec la même action, et c'est juste : dans les deux cas on demande
 * au serveur d'envoyer à cette adresse de quoi ouvrir une session.
 *
 * ⚠️ C'EST UN ENVOI D'E-MAIL, PAS UNE ROUTE DE MOT DE PASSE. Il n'existe aucune route
 * « réinitialiser » : la V1 demande au service d'e-mails d'envoyer le message dont
 * l'ACTION vaut 3, et c'est ce message qui porte le lien de retour. Le même appel sert
 * d'ailleurs à sa connexion « sans mot de passe ». Inventer une route ici répondrait
 * 404 ; reprendre la sienne fait fonctionner les modèles déjà écrits par les clients.
 *
 * ⚠️ ET IL VIT SUR APIX, pas sur api-v1 : `/emails/v3` n'existe pas sur la seconde
 * (vérifié, elle répond « Oops, cette route n'existe pas »). Il est PUBLIC, ce qui est
 * la condition pour qu'il serve à quelqu'un qui, justement, ne peut pas se connecter.
 */

/**
 * `skipped` veut dire « cet événement n'a AUCUN modèle pour cette action », pas
 * « adresse inconnue ». La différence compte : dans le premier cas, promettre un
 * courrier serait un mensonge, aucun ne partira jamais.
 */
export type SignInLinkSent = { sent: boolean };

export async function sendSignInLink(
  domainId: number,
  eventId: number,
  email: string,
  languageId?: number | null,
): Promise<SignInLinkSent> {
  /* L'adresse devant `?token=…` est celle réglée pour l'événement, côté serveur (voir
     `emails/send.ts`) : rien à envoyer d'ici. */
  return sendActionEmail(domainId, eventId, "link", { email }, { languageId });
}
